import router from '../router'
import store from '../store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { getToken, getUserId, getUserRole } from '@/utils/cookie'
import { asyncRouterMap } from '@/router'
import routerJson from '@/assets/router.json';
// permissiom judge
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin权限 直接通过
  if (permissionRoles && permissionRoles.length > 0) {
    return roles.some(role => permissionRoles.indexOf(role) >= 0)
  } else {
    return true
  }
}

function getSideBarShow(to) {
  let isShow = false;
  let childrenList = []
  let routerList = []
  asyncRouterMap.forEach(element => {
    if(to.path.indexOf(element.path) >= 0) {
      isShow = element.sidebarShow
      childrenList = element.children
    }
  });
  if (to.path.indexOf('act_') >= 0) {
    Object.keys(routerJson).forEach(key => {
      if (key === localStorage.getItem('app')) {
        childrenList.forEach(child => {
          routerJson[key].forEach(item => {
            if (child.path === item) {
              routerList.push(child)
            }
          })
          if (!child.parentName) {
            routerList.push(child)
          }
        })
      }
    })
    store.dispatch('setCurrentRouters', routerList)

  } else {
    store.dispatch('setCurrentRouters', childrenList)
  }

  return isShow;
}


// register global progress.
// 不重定向白名单
const whiteList = ['/login', '/authredirect']
router.beforeEach((to, from, next) => {
  NProgress.start()
  
  // 判断是否有密码
  if (getUserId() && getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if(to.query && to.query.app) {
        store.dispatch('setToolsApp', to.query.app)
      }
      if(to.path === '/data/data_submenu_active_main' && to.query && to.query.actId) {
        localStorage.setItem('dataActId', to.query.actId)
      } else if(!from.path.startsWith('/data/') && to.path === '/data/data_submenu_active_main' && !to.query.actId) {
        localStorage.setItem('dataActId', '')
      }
      // 设置是否显示左侧菜单
      store.dispatch('setCurrentRouters', "")
      

      let roles;
      if (getUserRole() === '3') {
        roles = ['verificate']
      } else if (getUserRole() === '4') {
        roles = ['prizeList']
      } else {
        roles = ['meta_common', 'verificate','prizeList']
      }
      
      if (store.getters.addRouters.length === 0) {
        store.dispatch('GenerateRoutes', roles).then(() => {
          router.addRoutes(store.getters.addRouters)
          // hack方法 确保addRoutes已完成
          if (getUserRole() === '3') {
            next('/verificate/verificate_index')
          } else {
            next({ ...to })
          }
        })
      } else {
        if (hasPermission(roles, to.meta)) {
          // 延时设置 保证创建活动后 路由更改成功
          setTimeout(() => {
            store.dispatch('setSidebarShow', getSideBarShow(to))
            next()
          }, 1)
        }
      }

    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      store.dispatch('FedLogOut').then(() => {
        next('/login')
        NProgress.done()
      })
    }
    
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/utils/permission.js